export default function Terms() {
  return (
    <div className="page-shell px-4 py-14 sm:px-6">
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-8 text-center text-4xl font-extrabold text-secondary">Terms and Conditions</h1>
        
        <p className="mb-8 text-center italic text-textMuted">
          Last updated: January 4, 2026
        </p>

        <div className="ui-card divide-y divide-slate-100 px-6 py-3 sm:px-10">
          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">1. Introduction</h2>
            <p className="mb-4 text-textMuted">
              Welcome to DeCipher ("we", "us", or "our"). These Terms and Conditions ("Terms") govern your access to and use of our website, services, and any related applications (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms.
            </p>
            <p className="text-textMuted">
              If you do not agree with these Terms, you must not use the Service.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">2. User Accounts</h2>
            <p className="mb-4 text-textMuted">
              To use certain features, you must create an account. You agree to provide accurate information and keep it updated. You are responsible for maintaining the confidentiality of your account credentials.
            </p>
            <p className="text-textMuted">
              We reserve the right to suspend or terminate accounts that violate these Terms.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">3. Subscriptions and Payments</h2>
            <p className="mb-4 text-textMuted">
              Our Service offers paid subscriptions. By subscribing, you authorize us to charge your payment method on a recurring basis.
            </p>
            <p className="mb-4 text-textMuted">
              All charges are non-refundable. Subscriptions renew automatically until canceled. You may cancel anytime via your account settings, but no refunds for partial periods.
            </p>
            <p className="text-textMuted">
              We use Stripe for payments. Their terms apply to transactions.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">4. Use of the Service</h2>
            <p className="mb-4 text-textMuted">
              You may use the Service for personal, non-commercial purposes. You agree not to:
              - Violate any laws
              - Upload harmful or illegal content
              - Attempt to reverse-engineer or hack the Service
              - Abuse rate limits or create multiple accounts to bypass restrictions
            </p>
            <p className="text-textMuted">
              We may terminate your access for violations without notice.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">5. Intellectual Property</h2>
            <p className="mb-4 text-textMuted">
              The Service and its content are owned by us or our licensors. You are granted a limited, non-exclusive license to use the Service. All generated content is your responsibility.
            </p>
            <p className="text-textMuted">
              Do not reproduce, distribute, or create derivative works from the Service without permission.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">6. Limitation of Liability</h2>
            <p className="mb-4 text-textMuted">
              The Service is provided "as is" without warranties. We are not liable for any indirect, incidental, or consequential damages.
            </p>
            <p className="text-textMuted">
              Our total liability shall not exceed the amount paid by you in the past 3 months.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">7. Changes to Terms</h2>
            <p className="text-textMuted">
              We may update these Terms. Continued use after changes constitutes acceptance.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">8. Governing Law</h2>
            <p className="text-textMuted">
              These Terms are governed by the laws of England.
            </p>
          </section>

          <section className="py-7">
            <h2 className="mb-4 text-2xl font-semibold text-secondary">9. Contact Us</h2>
            <p className="text-textMuted">
              For questions, contact us at deciphertextco@gmail.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}